import { render, staticRenderFns } from "./percentageReportV2.vue?vue&type=template&id=11c87c24&"
import script from "./percentageReportV2.vue?vue&type=script&lang=js&"
export * from "./percentageReportV2.vue?vue&type=script&lang=js&"
import style0 from "./percentageReportV2.vue?vue&type=style&index=0&id=11c87c24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports